var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.27405 8.37474C2.35854 8.29025 2.47471 8.24097 2.59792 8.24097H13.7712C13.9753 8.24097 14.0774 8.48738 13.9331 8.63171L11.7259 10.8389C11.6414 10.9234 11.5252 10.9727 11.402 10.9727H0.228793C0.0246189 10.9727 -0.0774681 10.7263 0.0668618 10.5819L2.27405 8.37474Z",
    fill: "url(#paint0_linear_25_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27405 0.133769C2.36206 0.0492834 2.47823 0 2.59792 0H13.7712C13.9753 0 14.0774 0.246417 13.9331 0.390747L11.7259 2.59794C11.6414 2.68242 11.5252 2.73171 11.402 2.73171H0.228793C0.0246189 2.73171 -0.0774681 2.48529 0.0668618 2.34096L2.27405 0.133769Z",
    fill: "url(#paint1_linear_25_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7259 4.22776C11.6414 4.14328 11.5252 4.09399 11.402 4.09399H0.228793C0.0246189 4.09399 -0.0774681 4.34041 0.0668618 4.48474L2.27405 6.69193C2.35854 6.77642 2.47471 6.8257 2.59792 6.8257H13.7712C13.9753 6.8257 14.0774 6.57928 13.9331 6.43495L11.7259 4.22776Z",
    fill: "url(#paint2_linear_25_43)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_43",
    x1: 12.7038,
    y1: -1.31843,
    x2: 4.97102,
    y2: 13.4929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_43",
    x1: 9.3226,
    y1: -3.08378,
    x2: 1.58983,
    y2: 11.7276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_43",
    x1: 11.0024,
    y1: -2.20681,
    x2: 3.26966,
    y2: 12.6046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10.9726,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.18ac05a23a6573e27767f0ee1363d706.svg";
export { ForwardRef as ReactComponent };